module.exports = __webpack_public_path__ + "assets/img/camera-capture.0c407fff.svg";